import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7fffd25c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "setPassword"
};
const _hoisted_2 = {
  class: "head_title"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回 ");

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-band-phone-bigtitle"
}, "注册", -1));

const _hoisted_5 = {
  class: "user-changepwd-form"
};
const _hoisted_6 = {
  class: "user-form-item"
};
const _hoisted_7 = {
  class: "select"
};
const _hoisted_8 = {
  class: "user-form-value"
};
const _hoisted_9 = {
  class: "user-form-item user-form-item1"
};
const _hoisted_10 = {
  class: "user-form-value"
};
const _hoisted_11 = {
  key: 1,
  class: "ipt-btn"
};
const _hoisted_12 = {
  class: "user-form-item user-form-item1"
};
const _hoisted_13 = {
  class: "user-form-value"
};
const _hoisted_14 = {
  class: "user-form-item user-form-item1"
};
const _hoisted_15 = {
  class: "user-form-value"
};
const _hoisted_16 = {
  class: "user-form-item user-form-item1"
};
const _hoisted_17 = {
  class: "user-form-value"
};
const _hoisted_18 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_19 = {
  class: "btm-btn"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");

  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");

  const _component_van_count_down = _resolveComponent("van-count-down");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    size: "22",
    name: "arrow-left",
    onClick: $setup.close
  }, null, 8, ["onClick"]), _hoisted_3]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_dropdown_menu, null, {
    default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
      modelValue: $setup.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.value = $event),
      options: $setup.option
    }, null, 8, ["modelValue", "options"])]),
    _: 1
  })]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.params.username = $event),
    type: "number",
    placeholder: "账号/手机号"
  }, null, 512), [[_vModelText, $setup.params.username]])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.params.code = $event),
    placeholder: "验证码"
  }, null, 512), [[_vModelText, $setup.params.code]])]), $setup.showFs ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "ipt-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.sendCode && $setup.sendCode(...args))
  }, "发送")) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_count_down, {
    onFinish: $setup.finish,
    time: $setup.time,
    format: "ss 秒"
  }, null, 8, ["onFinish", "time"])]))]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.params.invite_code = $event),
    placeholder: "邀请码（选填，没有可不填）"
  }, null, 512), [[_vModelText, $setup.params.invite_code]])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.params.password = $event),
    type: "password",
    placeholder: "密码"
  }, null, 512), [[_vModelText, $setup.params.password]])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.password2 = $event),
    type: "password",
    placeholder: "确认密码"
  }, null, 512), [[_vModelText, $setup.password2]])])])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
    class: "user-public-btn",
    style: {
      "margin-top": "55px",
      "flex": "1 1 0%"
    },
    onClick: _cache[7] || (_cache[7] = (...args) => $setup.register && $setup.register(...args))
  }, " 立即注册 ")]), _createElementVNode("div", _hoisted_19, [_createElementVNode("span", {
    onClick: _cache[8] || (_cache[8] = $event => $setup.toDetails('/login'))
  }, "已有账户？直接登录"), _hoisted_20])]);
}